/* Separator.tsx generated by @compiled/babel-plugin v0.38.1 */
import "./Separator.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
var separatorStyles = null;
export function ToolbarSeparator() {
  return /*#__PURE__*/React.createElement("span", {
    "data-testid": "editor-toolbar-seperator",
    className: ax(["_1e0c1o8l _1bsbt94y _4t3i1tcg _19pkze3t _otyrze3t _18u0u2gc _2hwxu2gc _uiztglyw _bfhk15ej"])
  });
}